import React from 'react';
const IconRatingThumbsUp = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M14.69 8H21C22.1 8 23 8.9 23 10V12C23 12.26 22.95 12.5 22.86 12.73L19.84 19.78C19.54 20.5 18.83 21 18 21H9C7.9 21 7 20.1 7 19V9C7 8.45 7.22 7.95 7.59 7.59L14.17 1L15.23 2.05C15.5 2.32 15.67 2.7 15.67 3.11L15.64 3.43L14.69 8ZM5 9H1V21H5V9Z" fill="#666666"/>
</svg>
);
};
export default IconRatingThumbsUp;